/* Linsoul events hub. Fork of the prototype engine (events.js): data from linsoul_event metaobjects,
   every string from section settings ([data-ls-events-config]), each part optional. No tracking or booking. */
(() => {
  'use strict';
  if (window.__lsEventsHub) return;
  window.__lsEventsHub = true;
  const dataNode = document.querySelector('[data-ls-events-data]');
  if (!dataNode) return;
  let events;
  try { events = JSON.parse(dataNode.textContent); } catch (_) { return; }
  const T = {};
  document.querySelectorAll('[data-ls-events-config]').forEach(n => {
    try { const c = JSON.parse(n.textContent); Object.keys(c).forEach(k => { T[k] = typeof c[k] === 'object' && !Array.isArray(c[k]) ? Object.assign(T[k] || {}, c[k]) : c[k]; }); } catch (_) {}
  });
  const t = (key, vars) => String(T[key] ?? '').replace(/\{(\w+)\}/g, (m, k) => vars && k in vars ? vars[k] : m);
  const types = T.types || {};
  const $ = (s, p = document) => p.querySelector(s);
  const $$ = (s, p = document) => [...p.querySelectorAll(s)];
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const path = {
    arrow:'<path d="M5 12h14m-6-6 6 6-6 6"/>', external:'<path d="M14 4h6v6m0-6-9 9M10 4H5v16h15v-7"/>',
    save:'<path d="M6 4h12v17l-6-4-6 4Z"/>', pin:'<path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 0 1 14 0Z"/><circle cx="12" cy="10" r="2.4"/>',
    community:'<circle cx="8" cy="7" r="3"/><path d="M2 21v-4a6 6 0 0 1 12 0v4M15 4a3 3 0 0 1 0 6m2 4a5 5 0 0 1 5 5v2"/>',
    expo:'<path d="M3 21V9l9-6 9 6v12M7 21V11h10v10M3 21h18M9 14h6m-6 4h6"/>',
    specialist:'<path d="M4 14v-3a8 8 0 0 1 16 0v3M4 13H2v7h5v-7Zm16 0h2v7h-5v-7Z"/>',
    calendar:'<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M7 3v4M17 3v4M3 10h18m-13 4h4m-4 3h6"/>',
    copy:'<rect x="8" y="8" width="12" height="13" rx="1"/><path d="M16 8V3H3v13h5"/>',
    info:'<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7v.1"/>'
  };
  const icon = name => (window.LsIcons && window.LsIcons.svg(name)) || `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">${path[name] || path.info}</svg>`;

  // Equal Earth projection fitted to events-world.svg (viewBox 1000x466); percent of the map box.
  function project(lat, lon) {
    const A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = Math.sqrt(3) / 2;
    const p = Math.asin(M * Math.sin(lat * Math.PI / 180)), p2 = p * p, p6 = p2 * p2 * p2;
    const x = (lon * Math.PI / 180) * Math.cos(p) / (M * (A1 + 3 * A2 * p2 + p6 * (7 * A3 + 9 * A4 * p2)));
    const y = p * (A1 + A2 * p2 + p6 * (A3 + A4 * p2));
    return {x: 18.48467 * x + 49.99901, y: -42.62431 * y + 56.21881};
  }
  events.forEach(e => {
    e.brands = Array.isArray(e.brands) ? e.brands : [];
    if (typeof e.lat === 'number' && typeof e.lon === 'number') { const p = project(e.lat, e.lon); e.mapX = p.x; e.mapY = p.y; }
  });
  window.LsEventsProject = project;
  const mapped = events.filter(e => typeof e.mapX === 'number');
  const byId = new Map(events.map(e => [e.id, e]));
  const regions = new Set(events.map(e => e.region).filter(Boolean));
  const years = [...new Set(events.map(e => e.start.slice(0,4)))].sort().reverse();
  if ($('#ev-region')) $('#ev-region').innerHTML = `<option value="all">${esc(t('anywhere'))}</option>` + [...regions].sort().map(r => `<option>${esc(r)}</option>`).join('');
  if ($('#ev-year')) $('#ev-year').innerHTML = `<option value="all">${esc(t('any_year'))}</option>` + years.map(y => `<option>${y}</option>`).join('');
  const STORAGE_KEY = 'linsoul.events.saved.v1';
  const PAGE = Number(T.page_size) || 9;
  let saved = new Set(), persistent = true, toastTimer, searchTimer, visible = PAGE;
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (Array.isArray(raw)) saved = new Set(raw.filter(id => byId.has(id)));
  } catch (_) { persistent = false; }
  const state = {scope:'upcoming',q:'',region:'all',type:'all',year:'all',view:'grid'};
  let mapScope = 'upcoming', selectedMapId = '', selectedEventId = '', lastFocus = null, previousOverflow = '';
  const eventDialog = $('#ev-event-dialog'), requestDialog = $('#ev-request-dialog');
  const hasCalendar = !!$('#ev-results');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animate = (target, from, to) => { if (window.gsap && !reduceMotion.matches) window.gsap.fromTo(target, from, Object.assign({clearProps:'transform,opacity,visibility', overwrite:true}, to)); };

  function dayInZone(zone, now = new Date()) {
    try {
      const p = new Intl.DateTimeFormat('en-CA', {timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
      const v = Object.fromEntries(p.map(x => [x.type,x.value]));
      return `${v.year}-${v.month}-${v.day}`;
    } catch (_) { return now.toISOString().slice(0,10); }
  }
  function phase(e, now = new Date()) {
    if (e.publicationStatus === 'cancelled' || e.publicationStatus === 'postponed') return e.publicationStatus;
    const today = dayInZone(e.timeZone, now);
    return today > e.end ? 'past' : today >= e.start ? 'live' : 'upcoming';
  }
  const isFuture = e => ['upcoming','live'].includes(phase(e));
  const dateObj = str => new Date(str+'T12:00:00Z');
  const LOCALE = T.date_locale || 'en-GB';
  function dateRange(e, full = false) {
    const opts = {month:full?'long':'short',day:'numeric',year:'numeric',timeZone:'UTC'};
    const f = new Intl.DateTimeFormat(LOCALE,opts), a = dateObj(e.start), b = dateObj(e.end);
    return e.start === e.end ? f.format(a) : f.formatRange ? f.formatRange(a,b) : `${f.format(a)} - ${f.format(b)}`;
  }
  function dateStamp(e) {
    const a = dateObj(e.start), b = dateObj(e.end), sameMonth=e.start.slice(0,7)===e.end.slice(0,7);
    return {day:e.start===e.end?String(a.getUTCDate()):sameMonth?`${a.getUTCDate()}&ndash;${b.getUTCDate()}`:esc(dateRange(e)),
      month:new Intl.DateTimeFormat(LOCALE,{month:'short',year:'numeric',timeZone:'UTC'}).format(a)};
  }
  const labelPhase = e => {
    const p = phase(e);
    return p === 'past' ? t(e.recap ? 'phase_past_report' : 'phase_past_record') : t('phase_' + p);
  };
  const sortUpcoming = (a,b) => a.start.localeCompare(b.start)||a.name.localeCompare(b.name);
  const sortPast = (a,b) => b.start.localeCompare(a.start)||a.name.localeCompare(b.name);
  const nextId = () => events.filter(isFuture).sort(sortUpcoming)[0]?.id;

  function announce(message) {
    const toast = $('#ev-toast'); if (!toast) return;
    clearTimeout(toastTimer);
    const host = eventDialog?.open ? eventDialog : requestDialog?.open ? requestDialog : document.body;
    if (toast.parentElement !== host) host.appendChild(toast);
    toast.textContent = message;
    toastTimer = setTimeout(() => { toast.textContent = ''; }, 4500);
  }
  function readState() {
    const p = new URL(location.href).searchParams;
    state.scope = ['upcoming','past','saved'].includes(p.get('scope')) ? p.get('scope') : 'upcoming';
    state.q = (p.get('q')||'').slice(0,100);
    state.region = regions.has(p.get('region')) ? p.get('region') : 'all';
    state.type = Object.hasOwn(types, p.get('type') || '') ? p.get('type') : 'all';
    state.year = years.includes(p.get('year')) ? p.get('year') : 'all';
    state.view = p.get('view') === 'list' ? 'list' : 'grid';
    if (!hasCalendar) return;
    $('#ev-query').value = state.q; $('#ev-region').value = state.region; $('#ev-format').value = state.type; $('#ev-year').value = state.year;
  }
  function updateURL(mode='push', eventId=selectedEventId) {
    const url = new URL(location.href);
    ['scope','q','region','type','year','view','event'].forEach(k => url.searchParams.delete(k));
    for (const [k,v] of Object.entries(state)) {
      if (v && !(['scope','view'].includes(k) ? v === ({scope:'upcoming',view:'grid'}[k]) : v === 'all')) url.searchParams.set(k,v);
    }
    if (eventId) url.searchParams.set('event', eventId);
    if (url.href !== location.href) { try { history[mode === 'replace' ? 'replaceState' : 'pushState']({}, '', url.href); } catch (_) {} }
  }
  function filterEvents() {
    const query = state.q.toLocaleLowerCase().trim();
    return events.filter(e => {
      const phaseMatch = state.scope === 'saved' ? saved.has(e.id) : state.scope === 'past' ? phase(e) === 'past' : isFuture(e);
      const text = [e.name,e.city,e.country,e.region,e.venue,e.venueArea,e.description,...e.brands].join(' ').toLocaleLowerCase();
      return phaseMatch && (state.region === 'all' || e.region === state.region) && (state.type === 'all' || e.type === state.type) && (state.year === 'all' || e.start.startsWith(state.year)) && (!query || text.includes(query));
    }).sort(state.scope === 'past' ? sortPast : (a,b) => {
      if (state.scope === 'saved' && isFuture(a) !== isFuture(b)) return isFuture(a) ? -1 : 1;
      return state.scope === 'saved' && !isFuture(a) && !isFuture(b) ? sortPast(a,b) : sortUpcoming(a,b);
    });
  }
  function eventPageURL(e) {
    const params = new URLSearchParams(location.search); params.delete('event');
    ['preview_theme_id','_fd','_ab'].forEach(k => params.delete(k));
    const from = params.toString();
    return e.url + (from ? '?from=' + encodeURIComponent(from) : '');
  }
  function cardPhoto(e) {
    const c = T.card_photos;
    if (!c) return '';
    const city = String(e.city || '').trim().toLowerCase();
    return (c.cities && c.cities[city]) || (c.event_photo && e.photo) || '';
  }
  function card(e) {
    const photo = cardPhoto(e);
    const ds = dateStamp(e), st = phase(e), future = isFuture(e), next = nextId() === e.id;
    const booth = future ? (e.booth ? t('booth', {booth: e.booth}) : t('booth_tba')) : t(e.recap ? 'card_archive' : 'card_original');
    const status = st === 'past' ? t('card_past') : labelPhase(e);
    return `<article class="ev-card ${next&&future?'ev-card--next':''}" data-phase="${st}" data-card-id="${esc(e.id)}"><div class="ev-card-top${photo?' ev-card-top--photo':''}">${photo?`<img class="ev-card-photo" src="${esc(photo)}" alt="" loading="lazy" decoding="async">`:''}<time class="ev-date-stamp" datetime="${e.start}" aria-label="${esc(dateRange(e))}"><span>${ds.day}</span><small>${esc(ds.month)}</small></time><span class="ev-type">${icon(e.type)}${esc(types[e.type])}</span></div><div class="ev-card-body"><p class="ev-card-location">${esc(e.city)}, ${esc(e.country)}</p><h3>${esc(e.name)}</h3><p class="ev-venue">${esc(e.venue)}</p><div class="ev-card-meta"><span class="ev-card-status">${esc(status)}</span><span class="ev-small">${esc(booth)}</span></div></div><div class="ev-card-footer"><a class="ev-full-page-link" href="${esc(eventPageURL(e))}" aria-label="${esc(t('view_more_aria',{name:e.name}))}">${esc(t('view_more'))} ${icon('arrow')}</a><button class="ev-quick-link" type="button" data-event="${esc(e.id)}" aria-label="${esc(t('quick_view_aria',{name:e.name}))}">${esc(t('quick_view'))}</button><button class="ev-icon-btn" type="button" data-save="${esc(e.id)}" aria-pressed="${saved.has(e.id)}" aria-label="${esc(t(saved.has(e.id)?'unsave_aria':'save_aria',{name:e.name}))}">${icon('save')}</button></div></article>`;
  }
  function renderCounts() {
    const set = (k, v) => { const n = $(`[data-count="${k}"]`); if (n) n.textContent = v; };
    set('upcoming', events.filter(isFuture).length); set('past', events.filter(e => phase(e) === 'past').length); set('saved', saved.size);
  }
  function renderCalendar() {
    if (!hasCalendar) return;
    const filtered = filterEvents(), shown = filtered.slice(0, visible);
    $$('button[data-scope]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.scope === state.scope)));
    $$('button[data-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.view === state.view)));
    renderCounts();
    const results = $('#ev-results');
    results.dataset.view = state.view; results.dataset.scope = state.scope;
    results.innerHTML = shown.map(card).join('');
    const term = t('term_' + state.scope);
    $('#ev-results-status').textContent = t(filtered.length === 1 ? 'results_one' : 'results_other', {count: filtered.length, scope: term})
      + (state.region !== 'all' ? t('in_region', {region: state.region}) : '') + (state.type !== 'all' ? t('with_type', {type: types[state.type]}) : '');
    $('#ev-reset').hidden = !(state.q || state.region !== 'all' || state.type !== 'all' || state.year !== 'all');
    $('#ev-showing').textContent = filtered.length ? t('showing', {shown: shown.length, total: filtered.length, scope: term}) : t('none');
    $('#ev-more').hidden = shown.length >= filtered.length;
    const empty = $('#ev-empty');
    empty.hidden = !!filtered.length;
    if (!filtered.length) {
      const savedEmpty = state.scope === 'saved' && !saved.size;
      const key = savedEmpty ? 'empty_saved' : state.scope === 'upcoming' ? 'empty_upcoming' : 'empty';
      const extra = state.scope === 'upcoming' ? `<button class="ev-text-link" type="button" data-open-past>${esc(t('explore_past'))}</button>${requestDialog ? `<button class="ev-text-link" type="button" data-request="city">${esc(t('suggest_city'))}</button>` : ''}` : '';
      empty.innerHTML = `<h3>${esc(t(key + '_title'))}</h3><p>${esc(t(key + '_text'))}</p><div class="ev-inline-actions"><button class="ev-btn ev-btn--light" type="button" data-empty-reset>${esc(t(savedEmpty ? 'explore_upcoming' : 'clear_filters'))}</button>${extra}</div>`;
    }
  }
  function resetFilters() {
    state.q = ''; state.region = 'all'; state.type = 'all'; state.year = 'all'; visible = PAGE;
    $('#ev-filters')?.reset(); updateURL(); renderCalendar();
  }

  const mapCanvas = $('#ev-map-canvas');
  function mapItems() {
    return mapped.filter(e => mapScope === 'all' || (mapScope === 'upcoming' ? isFuture(e) : phase(e) === 'past')).sort((a,b) => {
      if (isFuture(a) !== isFuture(b)) return isFuture(a) ? -1 : 1;
      return isFuture(a) ? sortUpcoming(a,b) : sortPast(a,b);
    });
  }
  function renderMap() {
    if (!mapCanvas) return;
    const items = mapItems();
    if (!items.some(e => e.id === selectedMapId)) selectedMapId = items[0]?.id || '';
    $$('[data-map-scope]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mapScope === mapScope)));
    const groups = [];
    const width = mapCanvas.getBoundingClientRect().width || 900;
    // Cluster near city markers to keep the 44px hit areas non-overlapping.
    for (const e of items) {
      const near = groups.find(g => Math.hypot((e.mapX-g.x)*width/100, (e.mapY-g.y)*width*.466/100) < 44);
      if (near) near.events.push(e); else groups.push({x:e.mapX, y:e.mapY, events:[e]});
    }
    $('#ev-map-pins').innerHTML = groups.map(g => {
      const current = g.events.find(e => e.id === selectedMapId) || g.events[0];
      const cities = [...new Set(g.events.map(e => e.city))];
      const label = cities.length === 1 ? cities[0] : cities.join(' / ');
      const aria = t(g.events.length === 1 ? 'pin_aria_one' : 'pin_aria_other', {label, count: g.events.length});
      const shown = cities.length > 2 ? t('nearby', {city: cities[0]}) : label;
      return `<button type="button" class="ev-map-pin" style="--pin-x:${g.x.toFixed(3)}%;--pin-y:${g.y.toFixed(3)}%" data-map-id="${esc(current.id)}" data-map-group="${g.events.map(e => esc(e.id)).join(',')}" data-past="${g.events.every(e => !isFuture(e))}" aria-pressed="${g.events.some(e => e.id === selectedMapId)}" aria-label="${esc(aria)}"><small>${esc(shown)}${g.events.length > 1 ? ' +' + (g.events.length - 1) : ''}</small></button>`;
    }).join('');
    const rail = $('#ev-city-rail');
    if (rail) rail.innerHTML = items.map(e => `<button type="button" data-map-city="${esc(e.id)}" aria-pressed="${e.id === selectedMapId}"><span>${esc(e.city)}</span><small>${esc(dateRange(e))}</small><span class="ev-sr">${esc(e.name)}</span></button>`).join('');
    renderMapSide();
  }
  function renderMapSide() {
    const side = $('#ev-map-selection'); if (!side) return;
    const e = byId.get(selectedMapId);
    if (!e) {
      side.innerHTML = `<div><h3>${esc(t('map_empty_title'))}</h3><p class="ev-venue">${esc(t('map_empty_text'))}</p></div>${requestDialog ? `<button class="ev-btn" type="button" data-request="city">${esc(t('suggest_city'))}</button>` : ''}`;
      return;
    }
    const next = nextId() === e.id;
    side.innerHTML = `<div><span class="ev-type">${icon(e.type)}${esc(next ? t('next_stop') : types[e.type])}</span><h3>${esc(e.city)}</h3><p class="ev-side-event-name">${esc(e.name)}</p><p class="ev-map-side-copy">${esc(e.description)}</p></div><div><p class="ev-date">${esc(dateRange(e,true))}</p><p class="ev-venue">${esc(e.venue)}</p><a class="ev-btn" href="${esc(eventPageURL(e))}">${esc(t(isFuture(e) ? 'plan_visit' : 'view_full'))} ${icon('arrow')}</a></div>`;
  }
  function selectMap(id, source) {
    if (!byId.has(id)) return;
    selectedMapId = id;
    $$('[data-map-id]').forEach(b => {
      const selected = b.dataset.mapGroup.split(',').includes(id);
      b.setAttribute('aria-pressed', String(selected)); if (selected) b.dataset.mapId = id;
    });
    $$('[data-map-city]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mapCity === id)));
    renderMapSide();
    animate('#ev-map-selection > *', {autoAlpha:0, y:5}, {autoAlpha:1, y:0, duration:.22, stagger:.025});
    if (source === 'pin') {
      const b = $(`[data-map-city="${CSS.escape(id)}"]`); if (b) b.scrollIntoView({block:'nearest', inline:'center', behavior:reduceMotion.matches ? 'auto' : 'smooth'});
      const e = byId.get(id); announce(t('pin_announce', {city:e.city, name:e.name, dates:dateRange(e)}));
    }
  }
  function toggleSave(id) {
    const e = byId.get(id); if (!e) return;
    const was = saved.has(id); was ? saved.delete(id) : saved.add(id);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify([...saved])); persistent = true; } catch (_) { persistent = false; }
    const active = document.activeElement;
    const activeInResults = $('#ev-results')?.contains(active);
    renderCalendar();
    $$(`[data-save="${CSS.escape(id)}"]`).forEach(b => { b.setAttribute('aria-pressed', String(!was)); b.setAttribute('aria-label', t(was ? 'save_aria' : 'unsave_aria', {name:e.name})); });
    if (eventDialog?.open) { const inside = eventDialog.contains(active); renderDetail(e, false); if (inside) $('[data-save]', eventDialog)?.focus({preventScroll:true}); }
    if (activeInResults) ($(`#ev-results [data-save="${CSS.escape(id)}"]`) || $(`[data-scope="${state.scope}"]`))?.focus({preventScroll:true});
    announce(t(was ? 'toast_removed' : 'toast_saved') + (persistent ? '' : ' ' + t('toast_storage')));
  }
  const externalLink = (url, label) => url ? `<a href="${esc(url)}" target="_blank" rel="noopener noreferrer">${esc(label)} ${icon('external')}</a>` : '';
  function renderDetail(e, initial = true) {
    const body = $('#ev-detail-body'); if (!body) return;
    const future = isFuture(e), archive = phase(e) === 'past';
    $('#ev-detail-context').textContent = labelPhase(e);
    const mapsQuery = e.address || [e.venue, e.city, e.country].filter(Boolean).join(', ');
    const lineup = e.brands.length
      ? `<p class="ev-small">${esc(t(e.recap ? 'brands_note_report' : 'brands_note_listing'))}</p><div class="ev-dialog-brand-tags">${e.brands.map(b => '<span>' + esc(b) + '</span>').join('')}</div>`
      : `<p class="ev-detail-copy">${esc(t(future ? 'lineup_future' : 'lineup_past'))}</p>`;
    body.innerHTML = `<span class="ev-type">${icon(e.type)}${esc(types[e.type])}</span><h2 id="ev-detail-title">${esc(e.name)}</h2><p class="ev-dialog-location">${icon('pin')}${esc(e.city)}, ${esc(e.country)}</p><p class="ev-detail-copy">${esc(e.description)}</p>`
      + `<dl class="ev-detail-grid"><div class="ev-detail-cell"><dt>${esc(t('dates_label'))}</dt><dd>${esc(dateRange(e,true))}<small>${esc(e.timeZone)}${e.hours ? ' / ' + esc(e.hours) : ''}</small></dd></div>`
      + `<div class="ev-detail-cell"><dt>${esc(t('venue_label'))}</dt><dd>${esc(e.venue)}${e.venueArea ? '<small>' + esc(e.venueArea) + '</small>' : ''}</dd></div>`
      + `<div class="ev-detail-cell"><dt>${esc(t(archive ? 'booth_archive_label' : 'booth_label'))}</dt><dd>${e.booth ? esc(e.booth) : esc(t(archive ? 'booth_archive_none' : 'booth_tba_long'))}</dd></div>`
      + `<div class="ev-detail-cell"><dt>${esc(t('admission_label'))}</dt><dd>${esc(archive ? t('admission_past') : future ? t('admission_future') : labelPhase(e))}<small>${esc(t(archive ? 'admission_past_note' : 'admission_note'))}</small></dd></div></dl>`
      + (e.address ? `<p class="ev-small">${esc(e.address)}</p>` : '') + (e.privateVenue ? `<p class="ev-small">${esc(t('private_note'))}</p>` : '')
      + `<div class="ev-detail-section"><h3>${esc(t(archive ? 'heard_archive' : 'heard_future'))}</h3>${lineup}</div>`
      + (e.registrationNote ? `<div class="ev-notice">${icon('info')}<p>${esc(e.registrationNote)}</p></div>` : '')
      + `<div class="ev-inline-actions">${future ? `<button class="ev-btn" type="button" data-calendar="${esc(e.id)}">${esc(t('add_calendar'))} ${icon('calendar')}</button>` : externalLink(e.source, t(e.recap ? 'report_link' : 'original_link'))}<button class="ev-btn ev-btn--light" type="button" data-save="${esc(e.id)}" aria-pressed="${saved.has(e.id)}">${icon('save')}${esc(t(saved.has(e.id) ? 'saved_label' : 'save_label'))}</button><button class="ev-text-link" type="button" data-share="${esc(e.id)}">${esc(t('copy_link'))} ${icon('copy')}</button></div>`
      + `<div class="ev-detail-links">${future ? externalLink(e.organizer || e.source, t('official_info')) : ''}${!e.privateVenue && mapsQuery ? externalLink('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(mapsQuery), t('maps')) : ''}${e.attendanceSource && e.attendanceSource !== e.source ? externalLink(e.attendanceSource, t('linsoul_calendar')) : ''}${externalLink(e.source, t(e.recap ? 'original_report' : 'event_source'))}</div>`
      + `<div class="ev-inline-actions"><a class="ev-btn" href="${esc(eventPageURL(e))}">${esc(t('full_page'))} ${icon('arrow')}</a></div>`
      + (e.checkedAt ? `<p class="ev-detail-proof">${esc(t('proof', {date: e.checkedAt}))}</p>` : '');
    if (initial) body.scrollTop = 0;
  }
  function lockPage() { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
  function unlockPage() { document.body.style.overflow = previousOverflow; }
  function openEvent(id, write = true) {
    const e = byId.get(id); if (!e) { announce(t('toast_not_found')); return; }
    if (!eventDialog) { location.href = eventPageURL(e); return; }
    if (requestDialog?.open) requestDialog.close();
    if (!eventDialog.open) { lastFocus = document.activeElement; lockPage(); }
    selectedEventId = id; renderDetail(e);
    if (!eventDialog.open) eventDialog.showModal();
    eventDialog.scrollTop = 0;
    if (write) updateURL('push', id);
    animate('#ev-detail-body', {autoAlpha:0, y:7}, {autoAlpha:1, y:0, duration:.24});
  }
  function openRequest(kind) {
    if (!requestDialog) return;
    if (eventDialog?.open) eventDialog.close();
    lastFocus = document.activeElement; $('#ev-request-kind').value = kind === 'host' ? 'host' : 'city';
    $('#ev-draft-result').hidden = true;
    $('#ev-request-title').textContent = t(kind === 'host' ? 'request_host_title' : 'request_city_title');
    lockPage(); requestDialog.showModal(); requestDialog.scrollTop = 0;
  }
  function onDialogClosed(dlg) {
    const closedId = selectedEventId;
    const toast = $('#ev-toast'); if (toast) { toast.textContent = ''; document.body.appendChild(toast); }
    unlockPage();
    if (dlg === eventDialog) { selectedEventId = ''; updateURL('replace', ''); }
    if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true});
    else if (dlg === eventDialog) ($(`#ev-results [data-event="${CSS.escape(closedId)}"]`) || $(`button[data-scope="${state.scope}"]`))?.focus({preventScroll:true});
  }
  [eventDialog, requestDialog].filter(Boolean).forEach(dlg => {
    document.body.appendChild(dlg);
    dlg.addEventListener('close', () => onDialogClosed(dlg));
    dlg.addEventListener('click', ev => {
      const r = dlg.getBoundingClientRect();
      if (ev.target === dlg && (ev.clientX < r.left || ev.clientX > r.right || ev.clientY < r.top || ev.clientY > r.bottom)) dlg.close();
    });
  });
  function icsEscape(s) { return String(s).replace(/\\/g,'\\\\').replace(/\r?\n/g,'\\n').replace(/;/g,'\\;').replace(/,/g,'\\,'); }
  function foldLine(s) {
    const enc = new TextEncoder(); let lines = [], line = '', bytes = 0;
    for (const c of s) { const len = enc.encode(c).length; if (bytes + len > 73) { lines.push(line); line = ' '; bytes = 1; } line += c; bytes += len; }
    lines.push(line); return lines.join('\r\n');
  }
  function calendarText(e) {
    const end = dateObj(e.end); end.setUTCDate(end.getUTCDate() + 1);
    const stamp = new Date().toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'');
    const link = e.organizer || e.source || new URL(e.url, location.origin).href;
    const lines = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Linsoul//Events//EN','CALSCALE:GREGORIAN','METHOD:PUBLISH','BEGIN:VEVENT',`UID:${e.id}@${location.hostname}`,`DTSTAMP:${stamp}`,`DTSTART;VALUE=DATE:${e.start.replace(/-/g,'')}`,`DTEND;VALUE=DATE:${end.toISOString().slice(0,10).replace(/-/g,'')}`,`SUMMARY:${icsEscape(t('ics_summary', {name:e.name}))}`,`LOCATION:${icsEscape(e.address || [e.venue, e.city, e.country].filter(Boolean).join(', '))}`,`DESCRIPTION:${icsEscape(t('ics_description', {zone:e.timeZone, url:link}))}`,`URL:${link}`,'STATUS:CONFIRMED','TRANSP:TRANSPARENT','END:VEVENT','END:VCALENDAR'];
    return lines.map(foldLine).join('\r\n') + '\r\n';
  }
  function downloadCalendar(id) {
    const e = byId.get(id); if (!e || !isFuture(e)) return;
    const url = URL.createObjectURL(new Blob([calendarText(e)], {type:'text/calendar;charset=utf-8'}));
    const a = document.createElement('a'); a.href = url; a.download = e.id + '.ics'; document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 3000);
    announce(t('toast_calendar'));
  }
  async function copyText(text, successMessage) {
    try { if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable'); await navigator.clipboard.writeText(text); announce(successMessage); return; }
    catch (_) {
      const field = document.createElement('textarea'); field.value = text; field.setAttribute('aria-label', t('copy_prompt')); field.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;';
      (eventDialog?.open ? $('#ev-detail-body') : requestDialog?.open ? $('.ev-dialog-body', requestDialog) : document.body).appendChild(field);
      field.select(); let ok = false; try { ok = document.execCommand('copy'); } catch (_) {} field.remove();
      if (ok) announce(successMessage); else window.prompt(t('copy_prompt'), text);
    }
  }

  document.addEventListener('click', ev => {
    const button = ev.target.closest('button'); if (!button) return;
    if (button.hasAttribute('data-event')) { openEvent(button.dataset.event); return; }
    if (button.hasAttribute('data-save')) { toggleSave(button.dataset.save); return; }
    if (button.hasAttribute('data-close-dialog')) { button.closest('dialog')?.close(); return; }
    if (button.hasAttribute('data-request')) { openRequest(button.dataset.request); return; }
    if (button.hasAttribute('data-calendar')) { downloadCalendar(button.dataset.calendar); return; }
    if (button.hasAttribute('data-share')) {
      const url = new URL(location.href); url.searchParams.set('event', button.dataset.share); url.searchParams.delete('preview_theme_id');
      copyText(url.href, t('toast_link')); return;
    }
    if (button.hasAttribute('data-scope')) { state.scope = button.dataset.scope; visible = PAGE; updateURL(); renderCalendar(); return; }
    if (button.hasAttribute('data-view')) { state.view = button.dataset.view; updateURL(); renderCalendar(); return; }
    if (button.hasAttribute('data-map-scope')) { mapScope = button.dataset.mapScope; renderMap(); return; }
    if (button.hasAttribute('data-map-id')) {
      const ids = button.dataset.mapGroup.split(','); let id = button.dataset.mapId;
      if (ids.length > 1 && ids.includes(selectedMapId)) id = ids[(ids.indexOf(selectedMapId) + 1) % ids.length];
      selectMap(id, 'pin'); return;
    }
    if (button.hasAttribute('data-map-city')) { selectMap(button.dataset.mapCity, 'city'); return; }
    if (button.hasAttribute('data-format-jump')) {
      if (!hasCalendar) return;
      state.type = button.dataset.formatJump; state.scope = events.some(e => e.type === state.type && isFuture(e)) ? 'upcoming' : 'past';
      state.q = ''; state.region = 'all'; state.year = 'all'; visible = PAGE;
      $('#ev-filters').reset(); $('#ev-format').value = state.type; updateURL(); renderCalendar();
      $('#ev-calendar').scrollIntoView({behavior:reduceMotion.matches ? 'auto' : 'smooth'});
      if (state.scope === 'past') announce(t('toast_format_archive', {type: (types[state.type] || '').toLowerCase()}));
      return;
    }
    if (button.hasAttribute('data-empty-reset')) { if (state.scope === 'saved') state.scope = 'upcoming'; resetFilters(); return; }
    if (button.hasAttribute('data-open-past')) { state.scope = 'past'; state.year = 'all'; if ($('#ev-year')) $('#ev-year').value = 'all'; visible = PAGE; updateURL(); renderCalendar(); }
  });
  if (hasCalendar) {
    $('#ev-reset').addEventListener('click', resetFilters);
    $('#ev-more').addEventListener('click', () => {
      const old = visible; visible += PAGE; renderCalendar(); $('#ev-results').children[old]?.querySelector('[data-event]')?.focus({preventScroll:true});
    });
    $('#ev-filters').addEventListener('submit', e => e.preventDefault());
    $('#ev-query').addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => { state.q = $('#ev-query').value; visible = PAGE; updateURL('replace'); renderCalendar(); }, 180); });
    [['#ev-region','region'],['#ev-format','type'],['#ev-year','year']].forEach(([selector, key]) => $(selector).addEventListener('change', () => { state[key] = $(selector).value; visible = PAGE; updateURL(); renderCalendar(); }));
  }
  let draftText = '';
  const requestForm = $('#ev-request-form');
  if (requestForm) {
    requestForm.addEventListener('submit', e => {
      e.preventDefault(); if (!e.target.reportValidity()) return;
      const f = Object.fromEntries(new FormData(e.target));
      const host = f.kind === 'host';
      const subject = t('mail_subject', {kind: t(host ? 'mail_kind_host' : 'mail_kind_city'), city: f.city, country: f.country});
      draftText = t('mail_body', {intro: t(host ? 'mail_intro_host' : 'mail_intro_city'), name: f.name, city: f.city, country: f.country, message: f.message});
      $('#ev-draft-text').textContent = draftText;
      $('#ev-mailto').href = 'mailto:' + (T.email || '') + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(draftText);
      $('#ev-draft-result').hidden = false; $('#ev-mailto').focus({preventScroll:true});
      $('#ev-draft-result').scrollIntoView({block:'nearest', behavior:reduceMotion.matches ? 'auto' : 'smooth'});
    });
    $('#ev-copy-draft').addEventListener('click', () => copyText(draftText, t('toast_draft')));
  }
  window.addEventListener('popstate', () => {
    readState(); visible = PAGE; renderCalendar();
    const id = new URL(location.href).searchParams.get('event');
    if (id && byId.has(id)) openEvent(id, false); else if (eventDialog?.open) eventDialog.close();
  });
  window.addEventListener('storage', e => {
    if (e.key !== STORAGE_KEY) return;
    try { const ids = JSON.parse(e.newValue || '[]'); saved = new Set(Array.isArray(ids) ? ids.filter(id => byId.has(id)) : []); renderCalendar(); if (eventDialog?.open) renderDetail(byId.get(selectedEventId), false); } catch (_) {}
  });
  $$('.ev-story-media img').forEach(img => { const loaded = () => { if (img.naturalWidth) img.dataset.loaded = 'true'; }; img.addEventListener('load', loaded); img.addEventListener('error', () => { img.style.display = 'none'; }); if (img.complete) loaded(); });
  let resizeTimer;
  window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(renderMap, 150); });
  const header = document.querySelector('[data-site-header]')?.closest('.shopify-section');
  if (header && 'ResizeObserver' in window) new ResizeObserver(() => document.documentElement.style.setProperty('--ls-events-head', Math.ceil(header.getBoundingClientRect().height + 20) + 'px')).observe(header);
  readState(); renderCalendar(); renderMap();
  const requested = new URL(location.href).searchParams.get('event');
  if (requested) { if (byId.has(requested)) openEvent(requested, false); else announce(t('toast_not_found')); }
  window.LINSOUL_EVENTS_API = Object.freeze({phase, dayInZone, calendarText, dateRange, recordCount: events.length});
})();
